import { styled, Flex } from '@withjoy/joykit';

export const StyledIconWrapper = styled(Flex)`
  background-color: transparent;
  padding-bottom: 8px;
  position: relative;

  svg {
    width: auto;
    height: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  /* Shop department icon svgs will have the 'jw-dep-icon' class name */
  .jw-dep-icon {
    /* Elements that are drawn via stroke and should be colored will have the 'themed-stroke' class name */
    .themed-stroke {
      stroke: currentColor !important;
    }

    /* Elements that are drawn via fill and should be colored will have the 'themed-fill' class name */
    .themed-fill {
      fill: currentColor !important;
    }
  }
`;
